import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { Button } from '../../../components/Button';
import { PopupContactForm } from '../../../components/PopupContactForm';
import { ScoreBar } from '../../../components/ScoreBar';
import { useStoryblokStrings } from '../../../hooks';
import { CoreContext } from '../../../providers';
import { dynamicTemplate } from '../../../services/dynamicTemplate';
import { media } from '../../../services/media';

export const Comparision = ({
    scoreData,
    comparisions,
    buttonCompare,
}: any) => {
    const { openPopup, settings } = useContext(CoreContext);
    const storyblokStringVariables = useStoryblokStrings(
        'my-score-string-variables',
    );

    if (!scoreData || !scoreData.comparisons || !storyblokStringVariables) {
        return null;
    }

    return (
        <Wrapper>
            {scoreData.comparisons && (
                <BarsGrid>
                    {scoreData.comparisons.map((item: any) => {
                        const keyString = item.text;
                        const text =
                            comparisions.find((c: any) => c.name === keyString)
                                .text || '';
                        const templateVariables = item.var;
                        let label = text;

                        if (templateVariables && text) {
                            // some of the template variables needs to be
                            // replaced with strings from the Storyblok
                            // before filling the final template string
                            Object.entries(templateVariables).forEach(
                                ([key, value]: any) => {
                                    if (value in storyblokStringVariables) {
                                        templateVariables[key] =
                                            storyblokStringVariables[value];
                                    }
                                },
                            );

                            label = dynamicTemplate(text, templateVariables);
                        }

                        return (
                            <ScoreBar
                                key={item.type}
                                score={item.score}
                                maxScore={item.maxScore}
                                minScore={item.minScore}
                                label={label}
                                onPlusClick={() =>
                                    openPopup(
                                        <PopupContactForm formType="challengeFriend" />,
                                    )
                                }
                            />
                        );
                    })}
                </BarsGrid>
            )}
            {buttonCompare && (
                <ButtonWrapper>
                    <Button
                        variant={
                            settings.languageVersion === 'pengestyrke'
                                ? 'boxed'
                                : 'primary'
                        }
                        onClick={() =>
                            openPopup(
                                <PopupContactForm formType="challengeFriend" />,
                            )
                        }
                    >
                        {buttonCompare}
                    </Button>
                </ButtonWrapper>
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    padding: 60px 0;
`;

const BarsGrid = styled.div`
    display: grid;
    padding: 60px 0;

    ${media.max('md')} {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    ${media.min('md')} {
        gap: 50px 100px;
        grid-template-columns: repeat(2, 1fr);
    }
`;

const ButtonWrapper = styled.div`
    text-align: center;

    .Button {
        ${media.max('xxl')} {
            width: 100%;
            max-width: 300px;
            padding: 20px;

            font-size: 20px;
            line-height: 1.3;
        }

        ${media.min('xxl')} {
            padding: 33px 45px;
            font-size: 27px;
            line-height: 1;
        }
    }
`;
